

export function decode (fieldValue: string) : ({slug: string, languagePackSlug: string} | false) {    
    if (!fieldValue) return false
    if (fieldValue.indexOf('__fbloflang__') === -1) return false       
    return {
        slug: fieldValue.substring(17),
        languagePackSlug: fieldValue.substring(13,15)
    }
}

export function encode(langPackSlug: string, slug: string) : string {
    return '__fbloflang__' + langPackSlug + '__' + slug
}
